module.exports = __webpack_public_path__ + "_assets/img/profile-07.fbf08107.svg";